import { defineMessages } from "react-intl"

import { CustomAttributeOptionSelectActionTypeAdd, CustomAttributeOptionSelectActionTypeRemove, CustomAttributeType } from "../../common/types"
import {
    ProductCustomDefinitionAttributes,
    ProductCustomDefinitionImageMetadata
} from "../../state/product-custom-attributes/CustomAttributeDefinition"

export const CUSTOM_ATTRIBUTE_EVENT = {
    ADD_ATTRIBUTE: "ADD_ATTRIBUTE" as const,
    DELETE_ATTRIBUTE: "DELETE_ATTRIBUTE" as const,
    CHECK_REQUIRED: "CHECK_REQUIRED" as const,
    UPDATE_ATTRIBUTE_LABEL: "UPDATE_ATTRIBUTE_LABEL" as const,
    UPDATE_ATTRIBUTE_MULTI_IMAGE_LABEL: "UPDATE_ATTRIBUTE_MULTI_IMAGE_LABEL" as const,
    SELECT_ATTRIBUTE_TYPE: "SELECT_ATTRIBUTE_TYPE" as const,
    CHECK_ALLOW_MORE_THAN_ONE_CHOICE: "CHECK_ALLOW_MORE_THAN_ONE_CHOICE" as const,
    UPDATE_MULTI_IMAGE_SELECT_ID: "UPDATE_MULTI_IMAGE_SELECT_ID" as const
}

export const CUSTOM_ATTRIBUTE_TYPE_TEXT = { label: "Text Field", value: "text" as CustomAttributeType }

export const CUSTOM_ATTRIBUTE_TYPE_SELECT = { label: "Select Field", value: "select" as CustomAttributeType }

export const CUSTOM_ATTRIBUTE_TYPES = [{ ...CUSTOM_ATTRIBUTE_TYPE_TEXT }, { ...CUSTOM_ATTRIBUTE_TYPE_SELECT }]

export const CUSTOM_ATTRIBUTE_DND_TYPE_CONSTANTS = {
    PARENT: "parent",
    CHILD: "child"
}

export const CUSTOM_ATTRIBUTES_MESSAGES = defineMessages({
    custom_attribute_placeholder: {
        id: "product.edit.custom_attribute_placeholder",
        defaultMessage: "Custom attribute label"
    },
    required_custom_attribute_label: {
        id: "product.edit.custom_attribute_required_placeholder",
        defaultMessage: "Required"
    },
    allow_more_than_more_choice_label: {
        id: "product.edit.custom_attribute_allow_more_than_more_choice_placeholder",
        defaultMessage: "Allow more than one choice"
    },
    allow_more_than_more_choice_possible_values_label: {
        id: "product.edit.custom_attribute_allow_more_than_more_choice_possible_values_label",
        defaultMessage: "Possible Values"
    },
    "customAttributeProposal.more_than_one_choice_helper_text": {
        id: "customAttributeProposal.more_than_one_choice_helper_text",
        defaultMessage: "You may select more than one choices"
    }
})

export const CUSTOM_ATTRIBUTE_DND_DROPPABLE = {
    ITEM: "droppableItem",
    SUB_ITEM: "droppableSubItem"
}

export const DEFAULT_CUSTOM_ATTRIBUTE: ProductCustomDefinitionAttributes = {
    id: "",
    attributeType: CUSTOM_ATTRIBUTE_TYPE_TEXT.value,
    allowMoreThanOneChoice: false,
    customFieldDefinitionLabel: {
        label: "",
        metadata: []
    },
    required: false,
    toDelete: false
}

export const DEFAULT_CUSTOM_ATTRIBUTE_MULTI_IMAGE_ATTRIBUTE: ProductCustomDefinitionImageMetadata = {
    images: null,
    resources: null,
    label: "",
    toDelete: false,
    id: ""
}

export const INVALID_STATUS = {
    FULLY_PAID: "fully-paid",
    APPROVED: "approved",
    PRE_APPROVED: "pre-approved",
    ORDERED: "ordered",
    INVOICED: "invoiced"
}
export const INVALID_STATUSES = Object.values(INVALID_STATUS)

export const VALID_DOCUMENT_TYPE = {
    QUOTE: "quote",
    PRICE_LIST: "price-list"
}

export const ITEM_TYPE = {
    PROVIDED_BY_CUSTOMER: "provided-by-customer",
    ACTIVE: "active"
}

export const VALID_DOCUMENT_TYPES = Object.values(VALID_DOCUMENT_TYPE)

export const NO_AVAILABLE_IMAGE_IMAGE_PATH = "/images/brokenImagePlaceholder/no_image_placeholder.png"

export const CUSTOM_ATRRTRIBUTES_SELECT_REMOVE_OPTION = "CUSTOM_ATRRTRIBUTES_SELECT_REMOVE_OPTION" as CustomAttributeOptionSelectActionTypeRemove

export const CUSTOM_ATRRTRIBUTES_SELECT_ADD_OPTION = "CUSTOM_ATRRTRIBUTES_SELECT_ADD_OPTION" as CustomAttributeOptionSelectActionTypeAdd

export const itemCustomAttributesMessages = defineMessages({
    "quote.item_custom_attributes_display.not_specified_msg": {
        id: "quote.item_custom_attributes_display.not_specified_msg",
        defaultMessage: "Not Specified"
    },
    "quote.item_custom_attributes_display.not_configured_msg": {
        id: "quote.item_custom_attributes_display.not_configured_msg",
        defaultMessage: "No values configured"
    }
})


// WEBPACK FOOTER //
// ./src/utils/customAttributes/constant.ts